'use client';

import Image from 'next/image';
import { FaLinkedin, FaGithub, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { FaUsers } from 'react-icons/fa';
import logo from '../../../../public/mursalin-logo.png';

import { getCount } from '@/utils/api';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [count, setCount] = useState(null);
  const [updatedAt, setUpdatedAt] = useState(null);

  // Fetch the visitor count when the component mounts
  useEffect(() => {
    const fetchCountData = async () => {
      try {
        const { count: visitorCount, updatedAt } = await getCount();
        setCount(visitorCount);
        setUpdatedAt(updatedAt);
      } catch (error) {
        console.error('Error fetching visitor count:', error.message);
      }
    };

    fetchCountData();
  }, []);

  // Copy text to clipboard
  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success(`${type} copied to clipboard!`);
    });
  };
  return (
    <footer className='bg-gradient-to-b from-gray-900 via-gray-950 to-gray-950 backdrop-blur-xl text-white py-10 pt-60'>
      <div className='container mx-auto px-6 md:px-12 lg:px-20'>
        <div className='flex flex-col items-center md:flex-row md:justify-between'>
          {/* Logo Section */}
          <div className='text-center md:text-left mb-6 md:mb-0'>
            <Image width={200} height={300} src={logo.src} alt='Logo' />
            <div className='mt-4 text-gray-400'>
              <p>Dhaka, Bangladesh</p>
            </div>
          </div>

          {/* Social Icons Section */}
          <div className='text-center'>
            <div className='flex justify-center space-x-6 mt-4'>
              <a
                href='https://linkedin.com/in/mursalin77'
                target='_blank'
                rel='noopener noreferrer'
                className='text-yellow-500 hover:text-yellow-400 transition duration-300'
              >
                <FaLinkedin size={24} />
              </a>
              <a
                href='https://github.com/tigermursa'
                target='_blank'
                rel='noopener noreferrer'
                className='text-yellow-500 hover:text-yellow-400 transition duration-300'
              >
                <FaGithub size={24} />
              </a>
              <a
                target='_blank'
                rel='noopener noreferrer'
                className='text-yellow-500 hover:text-yellow-400 transition duration-300 cursor-pointer'
                onClick={() => handleCopy('+8801782868063', 'WhatsApp number')}
              >
                <FaWhatsapp size={24} />
              </a>
              <a
                className='text-yellow-500 hover:text-yellow-400 transition duration-300 cursor-pointer'
                onClick={() =>
                  handleCopy('mursalinhossain377@gmail.com', 'Email')
                }
              >
                <FaEnvelope size={24} />
              </a>
            </div>

            {/* Motivational Text */}
            <p className='text-yellow-500 mt-4'>
              I enjoy learning and implementing and have big dreams in life.
            </p>
          </div>
        </div>

        {/* Copyright Section */}
        <div className='mt-8 border-t border-gray-700 pt-4 text-center '>
          <p className='text-gray-500 text-sm'>
            &copy; {currentYear} Mursalin Hossain. All rights reserved.
          </p>
          <p className='flex justify-center items-center gap-2 text-gray-600'>
            <FaUsers />
            <span className='text-xs'>{count || 'Loading...'}</span>
          </p>
          {/* {updatedAt && (
            <p className='text-gray-600 text-xs mt-1'>
              Last updated: {new Date(updatedAt).toLocaleString()}
            </p>
          )} */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
